exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".o-SearchHistory__list li:last-child {\n  border-bottom: none; }\n", ""]);

// exports
